const zh = {
  100000001:'关键信息',
  100000002:'币种简称',
  100000003:'副本创建者',
  100000004:'副本创建时间',
  100000005:'基础信息',
  100000006:'所属公链/协议',
  100000007:'智能合约地址',
  100000008:'发行时间',
  100000009:'发行总量',
  100000010:'流通总量',
  100000011:'市值',
  100000012:'简介',
  100000013:'社媒信息',
  100000014:'官网',
  100000015:'白皮书',
  100000016:'区块链浏览器',
  100000017:'项目评分',
  100000018:'排名',
  100000019:'前',
  100000020:'代码安全',
  100000021:'项目经营',
  100000022:'价格和流动性',
  100000023:'团队治理',
  100000024:'项目成熟度',
  100000025:'社区和社媒',
  100000026:'更新时间',
  100000027:'安全评分',
  100000028:'合约安全评分',
  100000029:'风险项目统计',
  100000030:'合约代码的明细',
  100000031:'购买税',
  100000032:'卖出税',
  100000033:'是否是蜜罐',
  100000034:'是否可再次 Mint',
  100000035:'是否有黑名单',
  100000036:'是否有白名单',
  100000037:'是否反鲸鱼',
  100000038:'是否可更改税率',
  100000039:'是否开源',
  100000040:'是否有隐藏的持有者',
  100000041:'是否可自毁',
  100000042:'是否是代理合约',
  100000043:'是否可以更改余额',
  100000044:'是否可执行外部调用',
  100000045:'是否可重新获取所有权',
  100000046:'是否有交易冷静期',
  100000047:'是否可暂停转账',
  100000048:'所有权未放弃',
  100000049:'是否是可调整的反鲸鱼',
  100000050:'小数位数过多',
  100000051:'公开的Mint和Burn方法',
  100000052:'燃烧代币是否会更新总量',
  100000053:'燃烧代币是否会更新余额',
  100000054:'自转账是否会增加余额',
  100000055:'转出大于余额的代币是否会失败',
  100000056:'余额在转账中未更新',
  100000057:'是否会消耗接收方余额',
  100000058:'调用TransferFrom超过余额时是否会失败',
  100000059:'BurnFrom方法是否会更新总量',
  100000060:'检测代币的购买税。5%以上被认为是高税率',
  100000061:'检测代币的卖出税。5%以上被认为是高税率',
  100000062:'检测代币是否是蜜罐骗局',
  100000063:'检查是否可以铸造更多代币',
  100000064:'检查代币是否有可以限制用户交换或转移代币的黑名单',
  100000065:'检查代币是否具有允许地址绕过任何限制的白名单。',
  100000066:'检查代币是否有反鲸鱼机制',
  100000067:'检查代币是否有税收，并且税收可以由特权角色修改',
  100000068:'检查代币是否已在区块链浏览器上验证',
  100000069:'检查代币是否有可以操纵合约的隐藏所有者，即使所有权似乎已被放弃',
  100000070:'检查代币是否可以自毁',
  100000071:'检查代币是否是将函数调用委托给实现合约的代理合约',
  100000072:'检查代币余额是否可以由特权角色修改',
  100000073:'检查代币是否调用外部合约',
  100000074:'检查代币是否有后门以重新获得所有权',
  100000075:'检查代币是否有转账冷却机制',
  100000076:'检查特权角色是否可以暂停代币交易',
  100000077:'检查所有者权限是否已放弃',
  100000078:'检查代币的反鲸鱼机制是否可以由特权角色修改',
  100000079:'检查‘decimals（）’函数的返回值是否大于或等于5',
  100000080:'检查随机用户调用 mint() 和 burn() 函数是否会回退',
  100000081:'检查调用“burn（）”函数是否会正确更新总量”',
  100000082:"检查调用' burnFrom（）'函数是否会正确更新余额",
  100000083:'检查与交易发起人相同的收件人调用“transfer（）”函数是否会增加发起人的余额',
  100000084:'检查调用金额超过余额的‘transfer（）’函数是否会失败',
  100000085:"调用' transferFrom（）'函数后检查消费者的余额是否有相应的更新",
  100000086:"检查调用' transferFrom（）'函数是否会使用消费者余额",
  100000087:"调用' transferFrom（）'后检查余额是否正确更新，或者如果金额无效，交易是否恢复",
  100000088:"检查调用“burnFrom（）”函数是否会正确更新总量",
  100000089:'检查是否存在造币权',
  100000090:'检查是否存在冻结权',
  100000091:'检查元数据是否可以更改',
  100000092:'致命',
  100000093:'严重',
  100000094:'中度',
  100000095:'轻度',
  100000096:'仅需知',
  100000097:'mint权限是否已放弃',
  100000098:'冻结权限是否已放弃',
  100000099:'是否可以更改代币的元数据',

  100000100:'您的年度报告正在生成中...',
  100000101:'欢迎来到',
  100000102:'您的2024年回顾',
  100000103:'我是你的私人向导',
  100000104:'带你一起回顾2024年走过的足迹',
  100000105:'开启报告',
  100000106:'{num}天前，命运的齿轮开始转动',
  100000107:'{userName} 我们的故事从这里开始',
  100000108:'为了共同的梦想，我们一路奔跑',
  100000109:'投资盈利明星',
  100000110:'年度总览钱包累计收益率',
  100000111:'您已领先 <em class="normal bold" style="color: #2AFF0A;">{percentage}</em> 用户',
  100000112:'在过去的一年里,拥有过铭文带来的 <em class="normal bold" style="color: #FFF;">FOMO</em>, 也享受过 <em class="normal bold" style="color: #FFF;">meme 暴涨</em> 的喜悦。现在，让我们一起走进您的记忆',
  100000113:'王牌交易员',
  100000114:'2024年度累计交易(次)',
  100000115:'累计交易金额($)',
  100000116:'你已超越了 <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> 的用户',
  100000117:'这不仅是数字的累积，更是您眼光与智慧的勋章',
  100000118:'每一次交易，都在迈向Web3.0的动力',
  100000119:'潜力新星',
  100000120:'Bitcoin在2024年最大跌幅达到<em class="normal">34%</em>，市场调整为常态，您的投资表现只是阶段性的结果，未来仍充满可能！',
  100000121:'稳健投资者',
  100000122:'每一次的观察和等待，都是为了迎接更精准的时机，期待2025年可以见到属于您的投资与盈利奇迹',
  100000123:'您在2024年交易次数最多的代币',
  100000124:'念念不忘，必有回响',
  100000125:'专注与付出，已在交易成果中熠熠生辉',
  100000126:'2024年Bitcoin在SuperEx的涨跌幅',
  100000127:'2024年你的Bitcoin涨跌幅',
  100000128:'恭喜你的资产实现增长！来年再接再厉',
  100000129:'2024年你还未持有Bitcoin',
  100000130:'卓越投资者',
  100000131:'稳健投资者',
  100000132:'学习型投资者',
  100000133:'你的现货主板区交易数据',
  100000134:'累计收益($)',
  100000135:'年化收益率(%)',
  100000136:'收益领先(%)',
  100000137:'你的合约交易数据',
  100000138:'展现了您在投资策略上的智慧，感谢您选择与我们同行!',
  100000139:'扬帆·再起航',
  100000140:'你不仅跟上了潮流，还是潮流的先锋！你在自由区上币 <em class="normal bold" style="color: #FFF;">{num1}</em> 次,交易了 <em class="normal bold" style="color: #FFF;">{num2}</em> 次。喜欢创新型产品的你，才是真正的冒险家！',
  100000141:'超级社交达人',
  100000142:'感谢您为我们带来了 <em class="normal bold" style="color: #FFF;">{num}</em> 个新面孔，平台因为你的推荐而蓬勃发展，通往Web3.0的道路上，期望有更多志同道合的朋友',
  100000143:'社交潜力新星',
  100000144:'有 <em class="normal bold" style="color: #FFF;">{num}</em> 名SuperEx用户,通过邀请好友赚取高达40%的交易佣金，2024的年你错过了，没关系。2025年请抓住机会。',
  100000145:'分享你的年度精彩时刻！分享到你的社区，鼓励更多人加入我们，一起解锁专属丰厚奖励，一起探索加密世界！',
  100000146:'邀请一名好友即可获得价值10USDT奖励!',
  100000147:'分享报告',
  100000148:'再次查看',
  100000149:'2024年,邀请人ID,你在Superex被称呼为',
  100000150:'你已超越平台用户的:',
  100000151:'现货主板区年化收益率:',
  100000152:'合约交易回报率:',
  100000153:'这一年，我是投资传奇！',
  100000154:'邀请码: {InviteCode}',
  100000155:'SuperEx.com - web3.0加密货币交易所交易所',
  100000156:'稳中求胜，实力尽显！',
  100000157:'这一年积累经验，新一年更精彩！',
  100000158:'你知道吗?',
  100000159:'SuperEx的现货自由区是全球最热门、最有潜力的Meme币交易平台',
  100000160:'2024,SuperEx新增 <em class="normal bold" style="color: #FFF;">{num}</em> 用户,作为全新家人',
  100000161:'属于你的2024回顾和2025千倍收益之旅即将起航',
  100000162:'这是一份Superex资深家人寄来的家书,里面记录了他们2024年的喜讯',
  100000163:'@To*** 用1USDT成功购买了1枚BTC,收益率高达 <em class="normal bold" style="color: #FFF;font-size:0.7rem">{percentage}%</em>。',
  100000164:'@1o*** 用1USDT获得了1枚ETH,收益率高达 <em class="normal bold" style="color: #FFF;font-size:0.7rem">{percentage}%</em>。',
  100000165:'@we*** 用1USDT获得了1台iphone15,收益率高达 <em class="normal bold" style="color: #FFF;font-size:0.7rem">{percentage}%</em>。',
  100000166:'还有更多精彩.......',
  100000167:'小资金、大回报、不断升级的玩法让每一次的参与都充满惊喜!',
  100000168:'现货、合约、理财...',
  100000169:'家书很长我们接着往下看',
  100000170:'累计首发代币 <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span> Superex奖继续致力于为用户创造更多的机会.',
  100000171:'年度钱包总览账户累计盈亏率',
  100000172:'钱包总览账户年度盈亏金额 <em class="normal bold {classNum}">{num}</em>',
  100000173:'您已领先了 <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> 的用户， 您在投资策略上的智慧，让人惊叹',
  100000174:'2025-SuperEx',
  100000175:'财富之路',
  100000176:'等你推开',
  100000177:'嗨 ! 我是SuperEx新朋友',
  100000178:'加入SuperEx，探索无穷可能，注册即享新手福利。',
  100000179:'用户@vb***参与现货主板区交易$ATOM累计收益率近 <em class="normal bold" style="color: #FFF;font-size:0.7rem">{percentage}%</em>。',
  100000180:'用户@xi***参与现货主板区交易$PIPE累计收益率近 <em class="normal bold" style="color: #FFF;font-size:0.7rem">{percentage}%</em>。',
  100000181:'用户@09***参与现货主板区交易$ATH累计收益率近 <em class="normal bold" style="color: #FFF;font-size:0.7rem">{percentage}%</em>。',
  100000182:'我们期待见证您在WEB3世界的交易所完成首笔交易，开启精彩篇章！',
  100000183:'1USD、Super Start、1000+现货、150X杠杆、1000X铭文、合约跟单、网格交易…',
  100000184:'多种高收益板块等您体验！',
  100000185:'涨跌有时，信念长存',
  100000186:'穿越波动，见证价值',
  100000187:'您的2024年度报告暂未生成。欢迎开启新一年的交易旅程，积累更多互动，届时即可解锁下一年度的专属总结！',
  100000188:'2024加密货币年度故事等你回顾！与SuperEx一起重温2024的高光时刻，快来分享你的专属瞬间吧！',
  100000189:'2024加密货币年度故事等你回顾!',
  100000190: '打开SuperExAPP查看「年度报告」',
  100000191: 'year年month月day日（UTC） ',
  100000192: '购买用户',
  100000193: '订单码',
  100000194: '我',
  100000195: '当前记录',
  100000196: '数字货币商品已发放。实物商品还请您联系客服领取',
  100000197: '购买成功',
  100000198: '{name}成功获得',
  100000199: '立刻抢',
  100000200: '加载到底部了',
  100000201: '恭喜{name}获得{shop}！',
  100000202: '用户{0}参与{1}成功！'
}
export default zh


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/zh.js